module.exports = __webpack_public_path__ + "img/success-check-circle.38edec76.svg";